import {
  Provider as MapProvider,
  Context as MapContext,
  useMap,
  withMap,
} from './Map';
/**
 *  useModules é responsavel por gerenciar os modulos do GeoBahia,
 *  todos os módulos criados na ADM.
 */
import {
  Provider as ModuleProvider,
  Context as ModuleContext,
  useModule,
  withModule,
} from './Module';

export const Providers = ({ children }) => {
  return (
    <ModuleProvider>
      <MapProvider>{children}</MapProvider>
    </ModuleProvider>
  );
};

export default Providers;
export { useMap, useModule, withMap, withModule, MapContext, ModuleContext };
